import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addAccessTokenModalTitle: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.add-access-token-modal-title',
		defaultMessage: 'Enter your personal access token',
		description: 'The header text for the modal',
	},
	cancelButton: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Button text for cancel',
	},
	submitButton: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.submit-button',
		defaultMessage: 'Submit',
		description: 'Button text for submit a token',
	},
	invalidAccessTokenModalTitle: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.invalid-access-token-modal-title',
		defaultMessage: 'Invalid personal access token',
		description: 'The header text for the modal',
	},
	cancelImportButton: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.cancel-import-button',
		defaultMessage: 'Cancel import',
		description: 'Button text for cancel import',
	},
	continueButton: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.continue-button',
		defaultMessage: 'Continue',
		description: 'Button text for continue',
	},
	accessTokenTextfieldLabel: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.access-token-textfield-label',
		defaultMessage: 'Personal access token',
		description: 'The label for the textfield',
	},
	accessTokenTextfieldPlaceholder: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.access-token-textfield-placeholder',
		defaultMessage: 'Paste your {thirdParty} token',
		description: 'The placeholder for the textfield',
	},
	accessTokenTextfieldErrorMessage: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.access-token-textfield-error-message',
		defaultMessage: 'Invalid token. Create a new personal access token and try again.',
		description: 'The error message for the textfield',
	},
	editTokenModalTitle: {
		id: 'project-create-importer-upload-flow.request-access-token-modal.edit-token-modal-title',
		defaultMessage: 'Edit personal access token',
		description: 'The header text for the modal',
	},
});
